<template lang="html">
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  	 width="516.375px" height="516.375px" viewBox="0 0 516.375 516.375" style="enable-background:new 0 0 516.375 516.375;"
  	 xml:space="preserve">
    <g>
    	<path d="M353.812,0C263.925,0,191.25,72.675,191.25,162.562c0,19.125,3.825,38.25,9.562,57.375L0,420.75v95.625h95.625V459H153
    		v-57.375h57.375l86.062-86.062c17.213,5.737,36.338,9.562,57.375,9.562c89.888,0,162.562-72.675,162.562-162.562S443.7,0,353.812,0
    		z M401.625,172.125c-32.513,0-57.375-24.862-57.375-57.375s24.862-57.375,57.375-57.375S459,82.237,459,114.75
    		S434.138,172.125,401.625,172.125z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Key'
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/Key.vue